import { useEffect, useState } from "react";
import ButtonIconH from "./ButtonIconH";
import InputData from "./InputData";
import { focusElement, userData, selectedOptic } from "../js/utils";
import { post } from "../js/post";

export function SendFile({ id, createPopupQuestion, removePopupQuestion }) {
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);

  const checkEmail = async () => {
    if (errorEmail || email === "") {
      createPopupQuestion(
        "Por favor, introduzca un email correcto.",
        () => {
          focusElement(20);
          setErrorEmail(false);
          removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    } else {
      setErrorEmail(false);
      await sendFile(id);
    }
  };

  async function sendFile(id) {
    const response = await post(
      "support-extra/gestionDocumental/EnviarFicheroGD.php",
      {
        token: userData.token,
        idFichero: id,
        email: email,
        idOptica: selectedOptic.id,
      },
    );
    // console.log(
      // "ENVIANDO FICHERO: ",
      // {
        // token: userData.token,
        // idFichero: id,
        // email: email,
        // idOptica: selectedOptic.id,
      // },
      // response,
    // );
    if (response.error !== "") {
      createPopupQuestion(
        response.error,
        () => {
          focusElement(20);
          removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    } else {
      createPopupQuestion(
        "Fichero enviado de forma correcta.",
        () => {
          focusElement(20);
          removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    }
  }

  useEffect(() => {
    focusElement(20);
  }, []);

  return (
    <div className="container-panel">
      <div className="opt-table-content grid-10" id="dashboard-export">
        <div className="cell combined-cells-2">Enviar por email</div>
        <div className="cell combined-cells-6 cell-start-content">
          <InputData
            type="type-email"
            tabIndex={20}
            size={0}
            input={email}
            onChange={(e) => {
              setEmail(e);
            }}
            onMalformed={() => setErrorEmail(true)}
            error={errorEmail}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">
          <ButtonIconH
            text="Enviar"
            small={true}
            onClick={async () => {
              await checkEmail();
            }}
          ></ButtonIconH>
        </div>
      </div>
    </div>
  );
}
